// Styles here will override Bulma styles
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const socialColumnStyled = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 0;

  > div:first-of-type {
    align-items: center;
    display: flex;

    .logo {
      height: 40px;
      margin-right: 20px;
      width: 40px;
    }

    .copyright {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
  }

  ${media('<tablet')} {
    flex-direction: column;
  }
`;

export const socialStyled = css`
  align-items: flex-start;
  display: flex;
  height: 32px;

  li {
    height: inherit;
    margin-right: 12px;

    :last-of-type {
      margin-right: 0;
    }

    a {
      display: inline-block;
      height: inherit;
      transition: opacity 0.1s ease;

      :hover {
        opacity: 0.75;
        transition: opacity 0.1s ease;
      }

      img {
        height: 32px;
      }
    }
  }

  ${media('<tablet')} {
    margin-top: 30px;
  }
`;
